import React, { Component } from "react";
import LazyLoad from "react-lazy-load";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { fetchPosts } from "../actions/postActions";
import { Helmet } from "react-helmet";
import loader from "../images/loader.svg";

class News extends Component {
  componentDidMount() {
    document.getElementById("root").classList.remove("welcome");
    document.getElementById("root").classList.remove("affiliate");
    document.getElementById("foo").classList.add("overflow");
    this.props.dispatch(fetchPosts());
  }

  render() {
    const { posts, error, loading } = this.props;
    posts.sort(function(a, b) {
      return new Date(b.date) - new Date(a.date);
    });

    const now = new Date();
    if (loading) {
      return (
        <div className="sub-page fadeInUp minHeight250">
          <section className="clearfix">
            <div className="container">
              <div className="center">
                <img src={loader} alt="Loading..." />
              </div>
            </div>
          </section>
        </div>
      );
    }
    if (error) {
      return (
        <div className="sub-page fadeInUp minHeight250">
          <section className="clearfix">
            <div className="container">
              <div className="center">Error! {error.message}</div>
            </div>
          </section>
        </div>
      );
    }
    const postList = posts.length ? (
      posts.map(post => {
        if (now >= new Date(post.start_date)) {
          return (
            <div className="card fadeInUp" key={post.newsId}>
              <Link to={"/post/" + post.newsId}>
                <div className="image">
                  <LazyLoad debounce={false} offsetVertical={500}>
                    <img src={post.image} alt={post.title} />
                  </LazyLoad>
                </div>
              </Link>
              <div className="card-content">
                <h4>{new Date(post.date).toDateString()}</h4>
                <h2
                  dangerouslySetInnerHTML={{
                    __html: post.title
                  }}
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: post.description
                  }}
                />
                <Link to={"/post/" + post.newsId}>
                  <span className="card-title">Read more →</span>
                </Link>
              </div>
            </div>
          );
        }
        return null;
      })
    ) : (
      <div className="sub-page fadeInUp minHeight250">
        <section className="clearfix">
          <div className="container">
            <div className="center">No posts to show</div>
          </div>
        </section>
      </div>
    );
    return (
      <div className="sub-page">
        <Helmet>
          <title>STech - News & Events</title>
          <meta name="description" content="STech News & Insights page" />
          <meta property="og:title" content="STech - News & Insights" />
          <meta
            property="og:description"
            content="STech News & Insights page"
          />
        </Helmet>
        <header className="clearfix fadeInUp">
          <div className="container">
            <div className="left" />
            <div className="right">
              <h1>News & Insights</h1>
              <h2>Stay in the know</h2>
            </div>
          </div>
        </header>
        <section className="clearfix">
          <div className="container">
            <div className="news">{postList}</div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    posts: state.posts.items,
    loading: state.posts.loading,
    error: state.posts.error
  };
};

export default connect(mapStateToProps)(News);
